import { Directive, TemplateRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[formFieldsSelectRow]',
    standalone: false
})
export class FormFieldsSelectRowDirective {
    constructor(public template: TemplateRef<any>) { }
}
